import React from 'react';
import { useIntl } from 'react-intl';
import { HistoryButtonsProps } from './types';
import useIsRtl from 'hooks/useIsRtl';
import SkapaDualButton from 'ui/DualButton/DualButton';
import UndoIcon from '@ingka/ssr-icon/paths/arrow-u-turn-backwards';
import RedoIcon from '@ingka/ssr-icon/paths/arrow-u-turn-forwards';

const HistoryFabs = ({ undoHandler, redoHandler, canRedo, canUndo }: HistoryButtonsProps) => {
  const { formatMessage } = useIntl();
  const isRtl = useIsRtl();

  return (
    <>
      <SkapaDualButton
        disabledFirst={!canUndo}
        disabledSecond={!canRedo}
        firstText={formatMessage({ id: 'storageone.sceneMenuHistoryUndo' })}
        secondText={formatMessage({ id: 'storageone.sceneMenuHistoryRedo' })}
        onClickFirst={undoHandler}
        onClickSecond={redoHandler}
        ssrIconFirst={UndoIcon}
        ssrIconSecond={RedoIcon}
        type="primary"
        small={true}
        flipIconRTL={isRtl}
      />
    </>
  );
};

export default HistoryFabs;
